<template>
	<div>
		<h1 class="title has-text-centered">{{ liga.nombre ? liga.nombre:'Nueva Liga' }}</h1>
		<h3 class="subtitle has-text-centered">{{ liga.id ? 'Editando Liga':'Creando Liga' }}</h3>

		<form @submit.prevent="update">
			<div class="field">
				<label class="label">Nombre</label>
				<div class="control">
					<input class="input" type="text" placeholder="Nombre de Liga.." v-model="liga.nombre"/>
				</div>
				<p class="help">Nombre de la Liga</p>
			</div>

			<div class="field is-grouped">
				<div class="control">
					<button class="button is-link">Guardar</button>
				</div>
				<div class="control">
					<button class="button is-link is-light" @click="goBack">
						Cancelar
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	import { mapState } from "vuex";

	export default {
		name: "Liga",
		data() {
			return {
      //liga: {}
  };
},
created() {
	if (this.$route.params.id && this.$route.params.id != "new") {
		this.$store.dispatch("ligas/fetchLiga", this.$route.params.id);
	} else {
		this.clearForm();
	}
},
computed: mapState("ligas", ["liga"]),
methods: {
	update() {
		console.log(this.liga);
		if (this.liga.id) {
			this.$store.dispatch("ligas/updateLiga", this.liga);
		} else {
			this.$store.dispatch("ligas/createLiga", this.liga);
		}
		this.goBack();
	},
	goBack() {
		this.$router.push({ name: "Ligas" });
	},
	clearForm() {
		this.$store.commit("ligas/SET_LIGA", {});
	}
}
};
</script>
